import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { spacing } from 'ui/theme';

export const Container = styled.section`
  max-width: ${({ theme }) => theme.spacing.values.normalPageMaxWidth};
  margin: 0 auto;
`;

export const EmptyStateContainer = styled.div`
  align-items: center;
  display: flex;
  height: ${pxToRem(300)};
  justify-content: center;
  margin-bottom: ${spacing.base};
`;
